import { SanityCell, SanityFeatSnippetTable } from "./FeaturedSnippetModule.d"
import tw from "twin.macro"
import React from "react"
import FeaturedSnippetPortableText from "./FeaturedSnippetPortableText"
import { Image } from "../../atoms/Image"

const FeaturedSnippetTable: React.FC<SanityFeatSnippetTable> = ({
  _key,
  table,
}) => {
  const isSanityCell = (cell: any): cell is SanityCell => {
    return cell && cell._type === "cell"
  }
  return (
    <div css={[tw`flex gap-x-5 w-full mt-8 bg-white`]} key={_key}>
      <table css={[tw`grid grid-cols-1 lg:(table table-fixed w-full)`]}>
        <thead css={[tw`hidden lg:contents`]}>
          <tr>
            {table?.rows[0]?.cells.map((cell, index) => (
              <th key={index} css={[tw`p-4`, tw`w-full text-left`]}>
                <h3
                  css={[
                    tw`font-light tracking-[6px] leading-[110%] text-2xl mb-4`,
                  ]}
                >
                  {cell?.name && cell.name}
                </h3>
              </th>
            ))}
          </tr>
        </thead>
        <tbody css={[tw`hidden lg:contents`]}>
          {table?.rows.slice(1).map((row, rowIndex) => (
            <tr key={rowIndex} css={[rowIndex % 2 !== 0 && tw`bg-gray-50`]}>
              {row.cells.map((cell, cellIndex) => {
                let content
                if (cell?._type == "rowTitle") {
                  content = <div>{cell?.name}</div>
                } else if (isSanityCell(cell) && cell?.content && cell?.image) {
                  content = (
                    <div css={[tw`grid grid-cols-2 items-center`]}>
                      <div css={[tw``]}>
                        <FeaturedSnippetPortableText
                          portableTextEditor={cell.content}
                          _key={cell._key}
                          _type={cell._type}
                        />
                      </div>
                      <Image
                        imageData={cell.image.image}
                        css={[tw`w-full object-cover min-h-[110px]`]}
                      />
                    </div>
                  )
                } else if (isSanityCell(cell) && cell?.content) {
                  content = (
                    <div css={[tw` h-full`]}>
                      <FeaturedSnippetPortableText
                        portableTextEditor={cell.content}
                        _key={cell._key}
                        _type={cell._type}
                      />
                    </div>
                  )
                }
                return (
                  <td
                    key={cellIndex}
                    css={[
                      tw`p-4`,
                      cell?._type == "rowTitle" && tw`font-semibold`,
                      cellIndex % 2 !== 0 &&
                        tw` md:(bg-gray-200 bg-opacity-30)`,
                    ]}
                  >
                    {content}
                  </td>
                )
              })}
            </tr>
          ))}
        </tbody>
        <tbody css={[tw`flex flex-col lg:hidden`]}>
          {table?.rows.slice(1).map((row, rowIndex) => (
            <tr key={rowIndex} css={[tw`flex flex-col`]}>
              {row.cells.map((cell, cellIndex) => (
                <td key={cellIndex} css={[tw`flex flex-col p-2`]}>
                  <h3 css={[tw` tracking-[6px] leading-[110%] mb-4`]}>
                    {table?.rows[0]?.cells[cellIndex]?.name}
                  </h3>
                  {cell?._type == "rowTitle" ? (
                    <div css={[tw`font-semibold`]}> {cell?.name}</div>
                  ) : isSanityCell(cell) && cell.content && cell.image ? (
                    <div
                      css={[
                        tw`grid grid-cols-2 p-2 items-center`,
                        cellIndex % 2 !== 0 && tw`bg-gray-50`,
                      ]}
                    >
                      <div css={[tw``]}>
                        <FeaturedSnippetPortableText
                          portableTextEditor={cell.content}
                          _key={cell._key}
                          _type={cell._type}
                        />
                      </div>
                      <div css={[tw`h-full min-h-[110px]`]}>
                        <Image imageData={cell.image.image} />
                      </div>
                    </div>
                  ) : (
                    isSanityCell(cell) && (
                      <div
                        css={[tw`p-2`, cellIndex % 2 !== 0 && tw`bg-gray-50`]}
                      >
                        <FeaturedSnippetPortableText
                          portableTextEditor={cell?.content}
                          _key={cell._key}
                          _type={cell._type}
                        />
                      </div>
                    )
                  )}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
export default FeaturedSnippetTable
